import { useEffect, useState } from "preact/hooks"
import { defaultConfig } from "../config"

const useSearchQuery = (once = false) => {
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        const searchInput = document.querySelector(defaultConfig.inputCssSelector);
        setSearchQuery(searchInput.value || '');

        const onChange = (event) => {
            setSearchQuery(event.target.value || '');
        }

        searchInput?.addEventListener("input", onChange, {once});

        return () => {
            searchInput?.removeEventListener("input", onChange, {once})
        }
    }, [])

    return {searchQuery}
}

export default useSearchQuery;